module.exports = __webpack_public_path__ + "img/2.765fd8d1.png";